import {
  calendarSettingsAddButton,
  calendarSettingsColumnLabel,
  calendarSettingsColumns,
} from 'shared/assets/styles';
import { Button } from 'shared/components/ui/button';
import styled from 'styled-components';

export const Section = styled.section`
  display: grid;
  gap: ${({ theme }) => theme.spacing(2)};
  padding: 0;
  margin: 0;
`;

export const List = styled.ul`
  display: grid;
  gap: ${({ theme }) => theme.spacing(2)};

  padding: 0;
  margin: 0;

  list-style: none;
`;

export const ListItem = styled.li``;
export const ListButton = styled.li`
  margin-left: ${({ theme }) => theme.spacing(-1.5)};
`;

export const HeaderRow = styled.li`
  ${calendarSettingsColumns};
`;

export const AccountColumnLabel = styled.span`
  ${calendarSettingsColumnLabel};
  grid-column: span 3;
`;

export const CalendarsColumnLabel = styled.span`
  ${calendarSettingsColumnLabel};
  grid-column: 4 / span 2;
`;

export const AddButton = styled(Button)`
  ${calendarSettingsAddButton};
`;
